import { stringify } from '@refinedev/simple-rest';
import { AxiosInstance } from 'axios';

import { DEVICE_URLS, USER_URLS } from '@/constants/urls';
import { UserNotification } from '@/model/General/Notification';

interface FirebaseTokenData {
  firebase_token: string;
  device_id: string;
  device_name: string;
  user_agent: string;
  base_os: string;
  timestamp: string;
  sent: boolean;
}
class UserApi {
  axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  /**
   * Envía el token de firebase a la API para su almacenamiento. Luego lo guarda en el localStorage
   */
  registerFirebaseToken(data: FirebaseTokenData): Promise<void> {
    return new Promise((resolve, reject) => {
      const params = stringify(data, {
        skipNull: true,
      });

      this.axiosInstance
        .post(`${DEVICE_URLS.SEND_TOKEN}`, params)
        .then(() => {
          console.log('Token de Firebase registrado correctamente');
          resolve();
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }

  /**
   * Obtiene las notificaciones del usuario desde la API
   */
  getUserNotification(): Promise<UserNotification[]> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .get(USER_URLS.NOTIFICATIONS, { params: { page_size: 5 } })
        .then((response: any) => {
          resolve(response?.data?.results || []);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }

  /**
   * Marca una notificación como leída en la API
   */
  markNotificationRead(id: string): Promise<UserNotification> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .post(`${USER_URLS.NOTIFICATIONS}/${id}/read`)
        .then((response: any) => {
          resolve(response?.data);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }
}

export default UserApi;
